import { render, staticRenderFns } from "./AdminAddGymPassDialog.vue?vue&type=template&id=9f92270c"
import script from "./AdminAddGymPassDialog.vue?vue&type=script&lang=js"
export * from "./AdminAddGymPassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports